export const VALIDATION_MESSAGES = {
  REQUIRED: "Це поле обов'язкове!",
  INVALID_EMAIL: "Будь ласка, введіть коректний email!"
}